<template>
  <div>
    <b-alert :show="error" variant="danger">
      {{ $t('can_not_login') }}
    </b-alert>
    <b-form v-on:submit="loginVelaeasy">
      <b-form-group>
        <b-form-input type="email"
                      v-model="login.email"
                      required
                      :placeholder="$t('edit_username')">
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input type="password"
                      v-model="login.password"
                      required
                      :placeholder="$t('edit_password')">
        </b-form-input>
      </b-form-group>
      <b-button type="submit" variant="primary">{{ $t('_login') }}</b-button>
    </b-form>
    <b-modal v-model="multiDomainModal" :title="$t('modal_select_domain')" :hide-footer="true">
      <multi-domain-modal v-bind:domains="domains" v-bind:email="login.email" v-bind:password="login.password" v-on:callback="closeModal"></multi-domain-modal>
    </b-modal>
  </div>
</template>

<script>

import MultiDomainModal from '@/components/MultiDomainModal'
import { mapActions, mapGetters } from 'vuex'

const regexEmail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/

export default {
  name: 'LoginVelaeasy',
  data () {
    return {
      login: {
        email: '',
        password: ''
      },
      multiDomainModal: false,
      domains: [],
      error: false
    }
  },
  components: {
    MultiDomainModal
  },
  computed: {
    ...mapGetters([
      'shappyInfo'
    ])
  },
  methods: {
    ...mapActions([
      'checkVelaeasyLoginAPI'
    ]),
    loginVelaeasy () {
      if (this.validateFormLogin()) {
        let param = {'appID': this.shappyInfo.appId,
          'channelID': this.shappyInfo.channelId,
          'channelName': this.shappyInfo.channelName,
          'email': this.login.email,
          'password': this.login.password,
          'domain': this.shappyInfo.domain,
          'package': this.shappyInfo.package
        }
        this.checkVelaeasyLoginAPI(param).then((result) => {
          if (result.status === 0 && result.data.publicShopKey) {
            this.$router.push({
              name: 'edit'
            })
          } else if (result.status === 0 && result.data.multi_domain === 1) {
            this.multiDomainModal = true
            this.domains = result.data.domain
          } else {
            this.error = true
          }
        })
      }
    },
    validateFormLogin () {
      if (!this.validateEmail()) {
        return false
      }
      if (!this.validatePassword()) {
        return false
      }
      return true
    },
    validateEmail () {
      if (this.login.email === '') {
        return false
      } else {
        if (!regexEmail.test(this.login.email)) {
          return false
        } else {
          return true
        }
      }
    },
    validatePassword () {
      if (this.login.password === '') {
        return false
      }
      return true
    },
    closeModal () {
      this.multiDomainModal = false
    }
  }
}
</script>
